import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxLengthExcludingAtValidator(
  maxLength: number,
  characterToExclude: string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = control.value.startsWith(characterToExclude)
      ? control.value.slice(1)
      : control.value;

    return value.length > maxLength
      ? { maxlength: { requiredLength: maxLength, actualLength: value.length } }
      : null;
  };
}
